/**
 * @generated SignedSource<<7b6d3a809f57245d8d0b16e479a9168d>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type TranscriptPanel_note$data = {
  readonly event: {
    readonly organizer: {
      readonly id: string;
    } | null;
  } | null;
  readonly id: string;
  readonly isLocked: boolean;
  readonly noteuserSet: ReadonlyArray<{
    readonly id: string;
    readonly user: {
      readonly email: string;
      readonly fullName: string;
      readonly id: string;
      readonly image: string;
      readonly isGuest: boolean;
    };
  }>;
  readonly viewerCanEdit: boolean;
  readonly " $fragmentSpreads": FragmentRefs<"TranscriptPanel_TranscriptSegment_note">;
  readonly " $fragmentType": "TranscriptPanel_note";
};
export type TranscriptPanel_note$key = {
  readonly " $data"?: TranscriptPanel_note$data;
  readonly " $fragmentSpreads": FragmentRefs<"TranscriptPanel_note">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "TranscriptPanel_note",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isLocked",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "viewerCanEdit",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "NoteUser",
      "kind": "LinkedField",
      "name": "noteuserSet",
      "plural": true,
      "selections": [
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "concreteType": "User",
          "kind": "LinkedField",
          "name": "user",
          "plural": false,
          "selections": [
            (v0/*: any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "email",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "fullName",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "isGuest",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "image",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Event",
      "kind": "LinkedField",
      "name": "event",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "User",
          "kind": "LinkedField",
          "name": "organizer",
          "plural": false,
          "selections": [
            (v0/*: any*/)
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "TranscriptPanel_TranscriptSegment_note"
    }
  ],
  "type": "Note",
  "abstractKey": null
};
})();

(node as any).hash = "282ccf46c45e7c255aefd3f9c71f61d9";

export default node;
